// extracted by mini-css-extract-plugin
export default {"badge":"wazzupSourceBadge_badge__MZZax","logo":"wazzupSourceBadge_logo__twMiz","type":"wazzupSourceBadge_type__Are-G"};